import { IconButton, Tooltip } from "@mui/material";
import { CgInfo } from "react-icons/cg";

const PillInfo = ({ notes }: { notes: string }) => {
  return (
    <Tooltip
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "preventOverflow",
              options: {
                boundary: "window",
              },
            },
          ],
        },
        tooltip: {
          sx: {
            fontSize: "1.2rem",
            backgroundColor: "#333",
            color: "white",
          },
        },
      }}
      title={notes}>
      <IconButton>
        <CgInfo />
      </IconButton>
    </Tooltip>
  );
};

export default PillInfo;
